module.exports = __webpack_public_path__ + "img/1958.7f45af60.png";